<template>
  <div>
    <Map v-if="accessToken" :accessToken="accessToken" :refreshToken="refreshToken" :renewTokens="renewTokens" :logout="logout"/>
    <ToAuth0 v-if="accessToken === null" :writeTokens="writeTokens"/>
	</div>
</template>

<script>
import Map from "@/components/Map.vue";
import ToAuth0 from "@/components/ToAuth0.vue";
export default {
  name: 'App',
  components: {
    Map,
    ToAuth0,
  },
  data() { 
    return {
      accessToken: localStorage.getItem('accessToken'),
      refreshToken: localStorage.getItem('refreshToken')
    };
  },
  computed: { 
  },
  methods: {
    writeTokens(access, refresh) {
      this.accessToken = access;
      if (access === null) {
        localStorage.removeItem('accessToken');
      } else {
        localStorage.setItem('accessToken', access);
      }

      if (refresh === null) {
        localStorage.removeItem('refreshToken');
      } else {
        localStorage.setItem('refreshToken', refresh);
      }
    },
    login(access, refresh) {
      this.writeTokens(access, refresh);
      this.refreshTokens(refresh);
    },
    logout() {
      this.writeTokens(null, null);
    },
    renewTokens(refresh) {
      fetch(`https://map.izone.ua/api/token/refresh/`, {
        method: "post",
        credentials: "same-origin",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          "refresh": refresh,
        }),
      }).then(response=>response.json()).then(json=> {
        if(json.code === "token_not_valid") {
          this.logout()
        } else {
          if(typeof this.writeTokens === 'function') {
            this.writeTokens(json.access, refresh);
          }
        }
      })
    }
  },
  mounted() {
  }
};
</script>